var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.79785 2.37109H15.4979C17.6865 3.92118 19.5948 5.83307 21.1409 8.02459V21.4061H6.79785V2.37109Z",
    fill: "url(#paint0_linear_232_529)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.79785 2.37109H15.4979C17.6865 3.92118 19.5948 5.83307 21.1409 8.02459V21.4061H6.79785V2.37109Z",
    stroke: "#012169",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4966 2.37109C17.6825 3.92491 19.5908 5.8362 21.1411 8.02459C20.6256 7.49486 20.0007 7.08413 19.3099 6.82115C18.6192 6.55816 17.8793 6.44927 17.1421 6.50209C17.2472 5.73008 17.1509 4.94401 16.8626 4.22018C16.5743 3.49636 16.1037 2.85938 15.4966 2.37109Z",
    fill: "url(#paint1_linear_232_529)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4966 2.37109C17.6825 3.92491 19.5908 5.8362 21.1411 8.02459C20.6256 7.49486 20.0007 7.08413 19.3099 6.82115C18.6192 6.55816 17.8793 6.44927 17.1421 6.50209C17.2472 5.73008 17.1509 4.94401 16.8626 4.22018C16.5743 3.49636 16.1037 2.85938 15.4966 2.37109V2.37109Z",
    stroke: "#012169",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.00439 4.87109H14.5794V6.89609H4.00439V4.87109Z",
    stroke: "#012169",
    strokeWidth: 4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8641 14.891C12.2136 14.2055 12.6141 13.4337 12.9291 12.6582L13.0551 12.3522C12.6396 10.7712 12.3906 9.50221 12.6134 8.68171C12.6601 8.57122 12.7407 8.47842 12.8435 8.41669C12.9463 8.35495 13.0661 8.32747 13.1856 8.33821H13.3761C13.7391 8.33296 13.9094 8.79421 13.9289 8.97346C13.9316 9.2451 13.896 9.51578 13.8231 9.77746C13.8409 9.49925 13.7998 9.22041 13.7024 8.95921C13.5524 8.62996 13.4091 8.43421 13.2809 8.40196C13.2352 8.43892 13.1982 8.48537 13.1723 8.53808C13.1464 8.59079 13.1322 8.6485 13.1309 8.70721C13.0928 8.94004 13.0735 9.17554 13.0731 9.41146C13.0908 10.105 13.2 10.7932 13.3979 11.4582C13.4384 11.3412 13.4729 11.2287 13.5029 11.123C13.5471 10.9565 13.8276 9.85471 13.8276 9.85471C13.8276 9.85471 13.7571 11.3217 13.6581 11.765C13.6371 11.8587 13.6139 11.9517 13.5891 12.0462C13.9212 12.9984 14.4722 13.8592 15.1979 14.5595C15.4829 14.8067 15.7949 15.0211 16.1279 15.1985C16.7527 15.1042 17.3837 15.0568 18.0156 15.0567C18.5224 15.0056 19.0322 15.1195 19.4691 15.3815C19.5654 15.4786 19.6223 15.6079 19.6289 15.7445C19.6256 15.8158 19.6153 15.8866 19.5981 15.956C19.6056 15.9177 19.6056 15.731 19.0319 15.5465C18.2681 15.4012 17.4849 15.3902 16.7174 15.5142C17.8919 16.0887 19.0371 16.3745 19.3994 16.2035C19.4758 16.1524 19.5424 16.0878 19.5959 16.013C19.5707 16.1371 19.534 16.2586 19.4864 16.376C19.4141 16.4678 19.3154 16.5353 19.2036 16.5695C18.6306 16.7195 17.1396 16.3685 15.8399 15.626C14.3724 15.8512 12.9257 16.1951 11.5139 16.6542C10.2576 18.8562 9.31261 19.8672 8.54461 19.4825L8.26186 19.3407C8.21031 19.2991 8.17259 19.2429 8.15371 19.1794C8.13483 19.1159 8.13566 19.0482 8.15611 18.9852C8.24536 18.5472 8.79511 17.8865 9.89911 17.2272C10.0176 17.1522 10.5471 16.8755 10.5471 16.8755C10.5471 16.8755 10.1549 17.255 10.0634 17.3292C9.18211 18.0515 8.53186 18.9597 8.54761 19.3122V19.343C9.29761 19.2365 10.4189 17.7125 11.8619 14.8887L11.8641 14.891ZM12.3194 15.1227C12.0931 15.5461 11.8615 15.9666 11.6249 16.3842C12.828 15.902 14.0787 15.5481 15.3561 15.3282C15.1911 15.2147 15.0317 15.0933 14.8784 14.9645C14.2197 14.3964 13.6838 13.6999 13.3034 12.9177C13.0252 13.6745 12.6952 14.4113 12.3156 15.1227",
    fill: "#F91D0A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8125 3.72656H15.7605V8.07881H2.8125V3.72656Z",
    fill: "url(#paint2_linear_232_529)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0071 8.33909H2.57764V3.46484H16.0071V8.33909ZM15.5249 3.94784H3.06064V7.85459H15.5249V3.94784Z",
    fill: "url(#paint3_linear_232_529)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19678 4.36497H7.13878C7.25772 4.35735 7.3769 4.3756 7.48812 4.41846C7.59934 4.46131 7.69995 4.52776 7.78303 4.61322C7.94455 4.81039 8.025 5.06164 8.00803 5.31597C8.02498 5.57144 7.94459 5.82385 7.78303 6.02247C7.69975 6.10752 7.59905 6.17355 7.48784 6.21601C7.37663 6.25847 7.25755 6.27637 7.13878 6.26847H6.76378V7.28022H6.19678V4.36497ZM6.76453 4.90947V5.72397H7.07878C7.1265 5.72669 7.17423 5.71859 7.21838 5.70028C7.26254 5.68197 7.30199 5.65392 7.33378 5.61822C7.39808 5.53189 7.42994 5.42568 7.42378 5.31822C7.43067 5.21067 7.39873 5.10421 7.33378 5.01822C7.30202 4.98247 7.26258 4.95439 7.21841 4.93607C7.17425 4.91776 7.12651 4.90969 7.07878 4.91247H6.76453V4.90947ZM8.97628 4.93572V6.71247H9.17953C9.27947 6.71915 9.37959 6.70227 9.47182 6.66319C9.56405 6.62411 9.64581 6.56392 9.71053 6.48747C9.84591 6.29372 9.911 6.05953 9.89503 5.82372C9.911 5.58929 9.84644 5.35644 9.71203 5.16372C9.64697 5.08728 9.56493 5.02712 9.47246 4.98806C9.38 4.94899 9.27969 4.93209 9.17953 4.93872H8.97628V4.93572ZM8.40853 4.37022H9.00853C9.25916 4.35745 9.51011 4.38815 9.75028 4.46097C9.91795 4.52621 10.064 4.63716 10.1718 4.78122C10.2771 4.91674 10.3553 5.07132 10.402 5.23647C10.4545 5.42669 10.4798 5.6234 10.477 5.82072C10.4798 6.01976 10.4545 6.2182 10.402 6.41022C10.3553 6.57536 10.2771 6.72994 10.1718 6.86547C10.0626 7.00995 9.91574 7.12154 9.74728 7.18797C9.50661 7.26102 9.2553 7.29272 9.00403 7.28172H8.40403V4.36497L8.40853 4.37022ZM10.9105 4.36497H12.4503V4.93347H11.4828V5.47572H12.3895V6.04422H11.4828V7.28022H10.915V4.36497",
    fill: "#FFF9F9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_232_529",
    x1: 10.9849,
    y1: 17.2823,
    x2: 16.2905,
    y2: 7.69336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_232_529",
    x1: 17.6678,
    y1: 5.79784,
    x2: 18.4838,
    y2: 5.04559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8C8C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_232_529",
    x1: 10.5442,
    y1: 9.77381,
    x2: 8.02875,
    y2: 2.03156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.127,
    stopColor: "#8A0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.244,
    stopColor: "#900000",
    stopOpacity: 0.999
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398,
    stopColor: "#A00000",
    stopOpacity: 0.999
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    stopColor: "#BC0000",
    stopOpacity: 0.998
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.761,
    stopColor: "#E20000",
    stopOpacity: 0.997
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867,
    stopColor: "#FA0000",
    stopOpacity: 0.996
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_232_529",
    x1: 10.6499,
    y1: 10.0798,
    x2: 7.93564,
    y2: 1.72409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.315,
    stopColor: "#5E0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444,
    stopColor: "#830000",
    stopOpacity: 0.999
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.618,
    stopColor: "#AE0000",
    stopOpacity: 0.998
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#CD0000",
    stopOpacity: 0.997
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.908,
    stopColor: "#E00000",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E70000",
    stopOpacity: 0.996
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.dc10d661e065b1b0655c41d0734a6b7d.svg";
export { ForwardRef as ReactComponent };